(function (root) {
  'use strict';
  let TEST = 'lp02_preview';
  let KEY = 'mori_ab_lp02_preview';
  const TTL = 30 * 24 * 60 * 60 * 1000;
  const THEME = '160051790016';
  const PRODUCTS = {
    '6915242754240': ['handcrafted-indigo-dyed-wood-round-tray'],
    '8152656380096': ['rays-plate-round-l-藍漆', 'rays-plate-round-l-urushi-pl-4']
  };
  function consent(api) {
    try {
      const value = api.currentVisitorConsent().analytics;
      if (value === 'no') return 'denied';
      if (value !== 'yes') return 'unknown';
      return api.analyticsProcessingAllowed() === true ? 'allowed' : 'unknown';
    } catch (_) { return 'unknown'; }
  }
  function eligible(win, config) {
    try {
      const theme = win.Shopify.theme;
      const u = new URL(win.location.href);
      const views = u.searchParams.getAll('view');
      const entries = u.searchParams.getAll('mori_ab_test');
      const handle = decodeURIComponent(u.pathname).match(/\/products\/([^/]+)\/?$/);
      return config.enabled === true && ['ja', 'en'].includes(config.language) &&
        String(theme.id) === THEME && (theme.role === 'unpublished' || (theme.role === 'main' && config.allowMain === true)) &&
        String(config.themeId) === THEME && config.themeRole === theme.role &&
        !!PRODUCTS[String(config.productId)] && handle &&
        PRODUCTS[String(config.productId)].includes(handle[1]) &&
        (theme.role === 'main' ? entries.length === 0 : entries.length === 1 && entries[0] === TEST) &&
        views.length <= 1 && (!views.length || views[0] === 'mori-value') &&
        (config.suffix === '' || config.suffix === 'mori-value');
    } catch (_) { return false; }
  }
  function valid(value, now) {
    return value && typeof value === 'object' && !Array.isArray(value) &&
      Object.keys(value).sort().join(',') === 'arm,expires,test' &&
      value.test === TEST && (value.arm === 'a' || value.arm === 'b') &&
      Number.isSafeInteger(value.expires) && value.expires > now && value.expires <= now + TTL;
  }
  function assignment(storage, now, random) {
    try {
      const raw = storage.getItem(KEY);
      let value;
      try { value = JSON.parse(raw); } catch (_) { value = null; }
      if (!valid(value, now)) {
        if (raw !== null) storage.removeItem(KEY);
        const draw = random();
        if (!Number.isFinite(draw) || draw < 0 || draw >= 1) return null;
        value = { test: TEST, arm: draw < 0.5 ? 'a' : 'b', expires: now + TTL };
      }
      const encoded = JSON.stringify(value);
      storage.setItem(KEY, encoded);
      if (storage.getItem(KEY) !== encoded) throw new Error('Storage unavailable');
      return value.arm;
    } catch (_) {
      try { storage.removeItem(KEY); } catch (_) {}
      return null;
    }
  }
  function destination(href, arm) {
    const u = new URL(href);
    if (arm === 'b') u.searchParams.set('view', 'mori-value');
    else u.searchParams.delete('view');
    if (arm) u.searchParams.set('mori_ab', TEST + '_' + arm);
    else {
      u.searchParams.delete('mori_ab');
      u.searchParams.delete('mori_ab_test');
    }
    return u.href;
  }
  function start(win, config, deps = {}) {
    TEST = config.themeRole === 'main' ? 'lp02_20261103' : 'lp02_preview';
    KEY = 'mori_ab_' + TEST;
    if (!eligible(win, config)) {
      if (String(config.themeId) === THEME && (config.suffix === 'mori-value' || new URL(win.location.href).searchParams.has('mori_ab'))) {
        const target = destination(win.location.href, null);
        if (target !== win.location.href) win.location.replace(target);
      }
      return null;
    }
    let navigating = false;
    let stopped = false;
    let timer;
    let loaded = false;
    let assigning = false;
    let previous = 'unknown';
    const now = deps.now || Date.now;
    const random = deps.random || (() => {
      const buffer = new Uint32Array(1);
      win.crypto.getRandomValues(buffer);
      return buffer[0] / 4294967296;
    });
    function removeOwn() {
      try { win.localStorage.removeItem(KEY); } catch (_) {}
    }
    function move(arm) {
      if (navigating || !eligible(win, config)) return;
      let target = destination(win.location.href, arm);
      const current = new URL(win.location.href);
      const requested = current.searchParams.get('view') === 'mori-value' ? 'b' : 'a';
      const rendered = config.suffix === 'mori-value' ? 'b' : 'a';
      if (arm && arm === requested && rendered !== requested) {
        stopped = true;
        target = destination(win.location.href, null);
      }
      if (target !== current.href) {
        navigating = true;
        win.location.replace(target);
      }
    }
    function fallback(state) {
      removeOwn();
      previous = state;
      stopped = true;
      move(null);
    }
    function evaluate() {
      if (stopped || navigating || !eligible(win, config)) return;
      const state = consent(win.Shopify.customerPrivacy);
      if (state === 'denied') {
        removeOwn();
        fallback(previous === 'allowed' ? 'withdrawn' : 'denied');
      } else if (state !== 'allowed') {
        fallback('unknown');
      } else {
        previous = 'allowed';
        if (assigning) return;
        if (!win.navigator?.locks?.request) { fallback('lock-unavailable'); return; }
        assigning = true;
        try {
          win.navigator.locks.request(KEY, () => {
            if (stopped || navigating || !eligible(win, config)) return;
            const latest = consent(win.Shopify.customerPrivacy);
            if (latest !== 'allowed') {
              if (latest === 'denied') removeOwn();
              fallback(latest === 'denied' ? 'withdrawn' : 'unknown');
              return;
            }
            let arm = null;
            try { arm = assignment(win.localStorage, now(), random); } catch (_) {}
            if (!arm) fallback('storage-unavailable');
            else {
              move(arm);
              if (!navigating && arm === 'b') win.document.documentElement.classList.add('mori-lp02-b-allowed');
            }
          }).catch(() => { if (!stopped && !navigating) fallback('lock-unavailable'); })
            .finally(() => { assigning = false; });
        } catch (_) { assigning = false; fallback('lock-unavailable'); }
      }
    }
    const changed = () => { if (loaded) evaluate(); };
    const storageChanged = event => {
      if (stopped || navigating || !eligible(win, config)) return;
      try {
        if (event.storageArea !== win.localStorage) return;
      } catch (_) { return; }
      if (event.key === null ||
          (event.key === KEY && event.oldValue !== null && event.newValue === null)) {
        fallback('storage-cleared');
      }
    };
    win.document.addEventListener('visitorConsentCollected', changed);
    win.addEventListener('storage', storageChanged);
    try {
      timer = win.setTimeout(() => { if (!loaded) fallback('api-timeout'); }, 4000);
      win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        win.clearTimeout(timer);
        if (stopped || loaded) return;
        if (error) { fallback('api-error'); return; }
        loaded = true;
        evaluate();
      });
    } catch (_) { win.clearTimeout(timer); fallback('api-error'); }
    return { state: () => previous, dispose: () => {
      stopped = true;
      win.clearTimeout(timer);
      win.document.removeEventListener('visitorConsentCollected', changed);
      win.removeEventListener('storage', storageChanged);
    } };
  }
  const api = { start, consent, eligible, assignment, valid, destination, KEY, TTL };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    const element = root.document.getElementById('mori-lp02-config');
    if (element) {
      try { start(root, JSON.parse(element.textContent)); } catch (_) {}
    }
  }
})(typeof window === 'undefined' ? globalThis : window);
